import React from 'react'

import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

/**
 * One expression's image input. Reports a `{base64, name}` payload (the shape
 * `admin.mascots.create/update` expects) up to the parent, or `null` when
 * cleared. `existingUrl` is the already-uploaded CDN image shown until replaced.
 */
export default function ExpressionUploader({ expression, value, existingUrl, onChange, required = false }) {
  const onPick = (e) => {
    if (!e.target.files || !e.target.files[0]) {
      return
    }
    const reader = new FileReader()
    reader.onloadend = () => {
      onChange(expression, { base64: reader.result, name: `${expression}.png` })
    }
    reader.readAsDataURL(e.target.files[0])
  }

  const preview = value ? value.base64 : existingUrl

  return (
    <Paper>
      <Stack padding={1} spacing={1} alignItems="center">
        <Typography variant="subtitle2" textTransform="capitalize">
          {expression}{required && <span style={{ color: '#d32f2f' }}> *</span>}
        </Typography>
        {preview && <img src={preview} alt={expression} width="96" height="96" />}
        <Button variant="outlined" component="label" size="small">
          {preview ? 'Replace' : 'Upload'}
          <input
            type="file"
            accept="image/png, image/jpeg, image/webp"
            hidden
            onChange={onPick}
          />
        </Button>
      </Stack>
    </Paper>
  )
}
